import React, {Fragment, useEffect, useState} from 'react'
import { Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import DatosTercero from './contactoTercero'
import {LoadingComponent}from 'recupero-comunes'

const ContactoTerceroModal = ({show, handleCloseModal}) => {
    const [loading, setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_proceso_extrajudicial

    const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
   const { datosUltimoContacto,loadingGlobal} = data_modal_contacto
    
    const [showToast, setShowToast] = React.useState(false);
    const [isHistorial, setIsHistorial] = React.useState(false)
    const [ultimaInstancias, setUltimaInstancias] = React.useState("")
    const dispatch = useDispatch()
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 

   useEffect(()=>{
    setUltimaInstancias(datosUltimoContacto &&
        datosUltimoContacto.datosUltimoContacto[0]['instancias'] !== undefined &&
        datosUltimoContacto.datosUltimoContacto[0]['instancias'] !== null &&
        datosUltimoContacto.datosUltimoContacto[0]['instancias'] !== ''
        ? datosUltimoContacto.datosUltimoContacto[0]['instancias']
        : '')
   },[datosUltimoContacto])
    useEffect(() => {
     
    }, [dispatch,llaves,datosGestionImplicado])
    
    return (
        <>
        <LoadingComponent show={loadingGlobal} />
            <Modal show={show}
                onHide={handleCloseModal}
                size='xl'>
                
                    <DatosTercero
                     ultimaInstancias={ultimaInstancias}
                     showToast={showToast}
                     setShowToast={setShowToast}
                     handleCloseModal={handleCloseModal}
                     handleShowToast={handleShowToast}
                     />
                    
               
            </Modal>
        </>
    )
}

export default ContactoTerceroModal
